import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getMyOrders } from '../../services/accountApi';

const inr = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;

const STEPS = ['pending', 'confirmed', 'shipped', 'delivered'];

export default function AccountOrders() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    if (!user) return;
    getMyOrders(user.id).then(({ data }) => {
      setOrders(data);
      setLoading(false);
    });
  }, [user]);

  if (loading) return <div className="account-loading">Loading orders…</div>;

  if (orders.length === 0) {
    return (
      <div className="account-empty">
        <p>No orders yet.</p>
        <p className="mini-sub">
          Placed an order over WhatsApp before signing up? Add that phone
          number in <Link to="/account/profile">My Details</Link> and we'll
          link its history to your account.
        </p>
        <Link to="/shop" className="account-btn-sm">
          Browse the collection
        </Link>
      </div>
    );
  }

  return (
    <div>
      <h3 className="account-h3">Order History</h3>

      <div className="order-list">
        {orders.map((o) => {
          const cancelled = o.order_status === 'cancelled';
          const stepIndex = STEPS.indexOf(o.order_status);

          return (
            <div key={o.id} className="order-card">
              <button
                className="order-card-head"
                onClick={() => setOpen(open === o.id ? null : o.id)}
              >
                <div>
                  <strong>{o.order_number}</strong>
                  <span className="mini-sub">
                    {o.created_at
                      ? new Date(o.created_at).toLocaleDateString('en-IN', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric',
                        })
                      : ''}
                    {' · '}
                    {(o.order_items || []).length} item
                    {(o.order_items || []).length === 1 ? '' : 's'}
                  </span>
                </div>
                <div className="mini-right">
                  <span className="order-total">{inr(o.final_amount)}</span>
                  <span className={`chip chip-${o.order_status}`}>
                    {o.order_status}
                  </span>
                  <span className="caret">{open === o.id ? '▾' : '▸'}</span>
                </div>
              </button>

              {open === o.id && (
                <div className="order-card-body">
                  {/* progress */}
                  {!cancelled && (
                    <div className="order-track">
                      {STEPS.map((s, i) => (
                        <div
                          key={s}
                          className={`track-step ${i <= stepIndex ? 'done' : ''}`}
                        >
                          <span className="track-dot" />
                          <span className="track-label">{s}</span>
                        </div>
                      ))}
                    </div>
                  )}

                  <ul className="order-items">
                    {(o.order_items || []).map((it) => (
                      <li key={it.id}>
                        <span>
                          {it.product_name}
                          <span className="mini-sub">
                            {' '}
                            {it.planet ? `(${it.planet})` : ''} × {it.quantity}
                          </span>
                        </span>
                        <span>{inr(it.total_price)}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="order-summary">
                    <div>
                      <span>Subtotal</span>
                      <span>{inr(o.total_amount)}</span>
                    </div>
                    <div>
                      <span>Shipping</span>
                      <span>{inr(o.shipping_charges)}</span>
                    </div>
                    {Number(o.discount_amount) > 0 && (
                      <div>
                        <span>Discount</span>
                        <span>−{inr(o.discount_amount)}</span>
                      </div>
                    )}
                    <div className="order-summary-total">
                      <span>Total</span>
                      <span>{inr(o.final_amount)}</span>
                    </div>
                  </div>

                  <p className="mini-sub">
                    Payment: {o.payment_status || 'pending'}
                  </p>
                  {o.shipping_address && (
                    <p className="ship-address-customer">
                      <strong>Delivering to</strong>
                      {'\n'}
                      {o.shipping_address}
                    </p>
                  )}

                  <a
                    className="account-btn-sm"
                    href={`https://wa.me/918796592272?text=${encodeURIComponent(
                      `Hello, I have a question about my order ${o.order_number}.`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    💬 Ask about this order
                  </a>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
